module.exports = __webpack_public_path__ + "static/media/element-plan.acbbc498.svg";